import { encode, ItemListPosition, NetworkType } from '@capsicum/common';
import { InfoCard, NetworkIcon } from '@capsicum/common-web';
import { type NetworkAndNetworkFeeCardProps } from '@capsicum/socios-core';
import styled from 'styled-components';

//It renders the Network Card and a optional Network Fee Card
export const NetworkAndNetworkFeeCard = ({
	networkAltFee,
	networkDefaultFee,
	networkFeeTitle,
	networkFeeTooltipText,
	networkRightText,
	networkTitle,
	testID
}: NetworkAndNetworkFeeCardProps) => (
	<S.Wrapper>
		<InfoCard
			icon={<NetworkIcon network={NetworkType.CC2} />}
			itemListPosition={networkDefaultFee ? ItemListPosition.START : ItemListPosition.SOLO}
			mainRightText={networkRightText}
			mainRightTitleSize="large"
			showDivider={!!networkDefaultFee}
			testID={`${testID}-network-card`}
			title={networkTitle}
		/>
		{networkDefaultFee && networkFeeTitle && (
			<InfoCard
				itemListPosition={ItemListPosition.END}
				mainRightText={networkDefaultFee}
				mainRightTitleSize="large"
				secondaryRightText={`${encode('doubleTilde')}${networkAltFee}`}
				testID={`${testID}-networkFee-card`}
				title={networkFeeTitle}
				tooltipPosition="top"
				tooltipText={networkFeeTooltipText}
			/>
		)}
	</S.Wrapper>
);

namespace S {
	export const Wrapper = styled.div`
		border-color: ${({ theme }) => theme.colors.borders.main.divider};
		border-style: ${({ theme }) => theme.borderStyles.divider.style};
		border-width: ${({ theme }) => theme.borderStyles.divider.width};
		${({ theme }) => theme.border.radius.medium};
	`;
}
